<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">
         <div class="logo" @click="redirect('/')" v-html="logo"></div>
        <nav :class="{ 'nav-burger': isMenuOpen }">
          <ul>
            <li
              v-for="(item, idx) in headers"
              :key="idx"
              :class="route.path == item.link ? 'active' : ''"
            >
              <span v-if="item.link !== '/products' && item.link !== '/services'" @click="redirect(item.link)">{{ item.name }}</span>
              <span class="dropdown" v-if="item.link === '/products' && !mobile">
                <div class="el" @click="redirect(item.link)">
                  {{ item.name }}
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="#555555" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <ul class="box">
                  <li v-for="link in productsLinks" @click="redirect('/products/' + link.slug)">{{link.title}}</li>
                </ul>
              </span>
              <span class="dropdown" v-if="item.link === '/products' && mobile" @click="openDropdownMenu">
                <div class="el">
                  {{ item.name }}
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{active: dropdown}">
                    <path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="#555555" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <ul class="box" :class="{active: dropdown}">
                  <li @click="redirect('/products/')">{{t('allProducts')}}</li>
                  <li v-for="link in productsLinks" @click="redirect('/products/' + link.slug)">{{link.title}}</li>
                </ul>
              </span>
              <span class="dropdown" v-if="item.link === '/services' && !mobile">
                <div class="el" @click="redirect(item.link)">
                  {{ item.name }}
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="#555555" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <ul class="box">
                  <li v-for="link in serviceCaregoriesData" @click="redirect('/services', '#' + link.slug)">{{link.title}}</li>
                </ul>
              </span>
              <span class="dropdown" v-if="item.link === '/services' && mobile" @click="openDropdownMenu2">
                <div class="el">
                  {{ item.name }}
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{active: dropdown2}">
                    <path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="#555555" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <ul class="box" :class="{active: dropdown2}">
                  <li @click="redirect('/services/')">{{t('allServices')}}</li>
                  <li v-for="link in serviceCaregoriesData" @click="redirect('/services', '#' + link.slug)">{{link.title}}</li>
                </ul>
              </span>
            </li>
          </ul>
        </nav>
        <!-- {{ t("home") }} -->
        <div class="header__flex">
          <div class="header__language">
            <div
              class="language"
              @mouseover="openDropdownLang"
              @mouseleave="closeDropdownLang"
              @click="toggleDropdownLang"
            >
              <div class="language-wrap">
                <span>{{ locale }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M5 7.5L10 12.5L15 7.5"
                    stroke="#555555"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <ul class="language-list" v-show="isDropdownOpenLang">
                <li
                  v-for="lang in availableLanguages"
                  :key="lang"
                  @click="changeLanguage(lang)"
                  :class="{ 'active-lang': lang == locale }"
                >
                  {{ lang }}
                </li>
              </ul>
            </div>
          </div>
          <div class="burger-menu" @click="hiddenByOpen">
            <svg
              v-if="isMenuOpen === false"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 12H21M3 6H21M3 18H21"
                stroke="#344054"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#667085"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script >
import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import logo from '!!raw-loader!@/assets/images/logo.svg'
import {
  SUPPORT_LOCALES as supportLocales,
  setI18nLanguage,
} from "@/helpers/i18n";
import axiosInstance from '@/helpers/instance';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isMenuOpen = ref(false);
    const isDropdownOpenLang = ref(false);
    const availableLanguages = ["en", "ru", "kz"];
    const mobile = ref(false);
    const dropdown = ref(false);
    const dropdown2 = ref(false);
    const productsLinks = ref([]);
    const serviceCaregoriesData = ref([]);

    const { t, locale } = useI18n({ useScope: "global" });

    const getData = async () => {
      await axiosInstance.get('/api/categories/header?lang=' + locale.value, {
        headers: {
          'Accept-Language': locale.value
        }
      }).then((response) => {
        productsLinks.value = response.data.data;
      })

      await axiosInstance.get('/api/services/categories/header', {
        headers: {
          'Accept-Language': locale.value,
        }
      }).then((res) => {
        serviceCaregoriesData.value = res.data.data;
      })
    }

    const headers = computed(() => [
      {
        name: t("home"),
        link: "/",
      },
      {
        name: t("about"),
        link: "/about",
      },
      {
        name: t("products"),
        link: "/products",
      },
      {
        name: t("services"),
        link: "/services",
      },
      {
        name: t("projects"),
        link: "/projects",
      },
      {
        name: t("news"),
        link: "/news",
      },
      {
        name: t("contacts"),
        link: "/contacts",
      },
    ]);

    const redirect = (event, hash) => {
      if (hash) {
        router.push({ path: event, hash: hash });
      }
      else {
        router.push({ path: event });
      }
      isMenuOpen.value = false;
    };

    const openDropdownLang = () => {
      if (window.innerWidth > 769) {
        isDropdownOpenLang.value = true;
      }
    };

    const closeDropdownLang = () => {
      if (window.innerWidth > 769) {
        isDropdownOpenLang.value = false;
      }
    };

    const toggleDropdownLang = () => {
      if (window.innerWidth <= 769) {
        isDropdownOpenLang.value = !isDropdownOpenLang.value
      }
    };

    const changeLanguage = (lang) => {
      setI18nLanguage(lang);
    };

    const hiddenByOpen = () => {
      isMenuOpen.value = !isMenuOpen.value
      if (isMenuOpen.value) {
        document.querySelector('html').style.overflow = 'hidden';
      }
      else {
        document.querySelector('html').style.overflow = 'auto';
      }
    }

    // watch(() => route.path, (newVal, oldVal) => {
    //   console.log(newVal)
    //   document.querySelector('html').style.overflow = 'auto';
    // })

    watch(
        isMenuOpen, // либо () => isMenuOpen.value
        (newVal, oldVal) => {
          // console.log('Меню:', oldVal, '→', newVal)
          if (!newVal) {
            document.querySelector('html').style.overflow = 'auto';
          }
          // document.querySelector('html').style.overflow = 'auto';
        }
    )

    return {
      headers,
      router,
      route,
      redirect,
      isMenuOpen,
      openDropdownLang,
      closeDropdownLang,
      toggleDropdownLang,
      availableLanguages,
      isDropdownOpenLang,
      changeLanguage,
      locale,
      t,
      mobile,
      dropdown,
      dropdown2,
      getData,
      productsLinks,
      hiddenByOpen,
      serviceCaregoriesData,
      logo: logo.default || logo
    };
  },
  methods: {
    openDropdownMenu() {
      this.dropdown = !this.dropdown;
    },
    openDropdownMenu2() {
      this.dropdown2 = !this.dropdown2;
    },
  },
  mounted() {
    // fetch data
    this.getData()
    // check mobile or desktop
    if(window.innerWidth <= 769) {
      this.mobile = true;
    }
    else {
      this.mobile = false;
    }
    addEventListener("resize", (event) => {
      if(window.innerWidth <= 769) {
        this.mobile = true;
      }
      else {
        this.mobile = false;
      }
    })
  },
  watch: {
    locale: function (
      currentLocale,
    ) {
      // window.location.reload();
      // console.log(currentLocale)
      this.getData();
    },
    route: function (newRouter) {
      document.querySelector('html').style.overflow = 'auto';
    }
  }
};
</script>

<style></style>
